import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as Cesium from 'cesium';

export interface DrawingPoint {
  x: number;
  y: number;
  color: string;
  width: number;
}

export interface DrawingAction {
  type: 'draw' | 'erase' | 'clear';
  points?: DrawingPoint[];
  color?: string;
  width?: number;
}

@Injectable({
  providedIn: 'root'
})
export class WhiteboardingService {
  private currentColor = new BehaviorSubject<string>('#ff3b30');
  private currentWidth = new BehaviorSubject<number>(5);
  private drawings: any[] = [];
  private viewer: any;
  private isDrawing = false;

  constructor() {}

  setViewer(viewer: any) {
    this.viewer = viewer;
  }

  getCurrentColor() {
    return this.currentColor.asObservable();
  }

  getCurrentWidth() {
    return this.currentWidth.asObservable();
  }

  setColor(color: string) {
    this.currentColor.next(color);
  }

  setWidth(width: number) {
    this.currentWidth.next(width);
  }

  addDrawing(drawing: any) {
    this.drawings.push(drawing);
  }

  undo() {
    if (this.viewer && this.drawings.length > 0) {
      const lastDrawing = this.drawings.pop();
      if (lastDrawing) {
        this.viewer.entities.remove(lastDrawing);
      }
    }
  }

  clearCanvas() {
    if (this.viewer) {
      this.viewer.entities.removeAll();
    }
    this.drawings = [];
  }

  getDrawings() {
    return this.drawings;
  }

  setIsDrawing(isDrawing: boolean) {
    this.isDrawing = isDrawing;
  }

  isDrawingActive() {
    return this.isDrawing;
  }
} 